
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.136 17.963c-2.719-.377-5.105-1.962-7.034-3.845C2.214 12.25.615 9.947.105 7.304c-.271-1.331.01-2.848 1.062-3.781.604-.657 1.39-1.474 2.378-1.125.841.268 1.315 1.094 1.963 1.644.698.558 1.28 1.45.91 2.364-.15.715-1.268 1.038-1.183 1.725a16.467 16.467 0 004.722 4.693c.672-.111.994-1.104 1.74-1.246.95-.347 1.789.336 2.367 1.02.623.713 1.622 1.28 1.637 2.337-.007 1.038-.97 1.635-1.611 2.308-.839.627-1.925.85-2.954.72zm1.264-1.156c.905-.16 1.515-.9 2.103-1.539.305-.884-.87-1.326-1.298-1.957-.446-.825-1.418-.888-1.891-.053-.424.418-1.019 1.287-1.653.68a16.7 16.7 0 01-5.739-5.86c-.118-.91 1.107-1.3 1.468-2.045.179-.823-.864-1.225-1.273-1.819-.401-.622-1.266-1.149-1.786-.338-.818.652-1.396 1.693-1.2 2.758.265 2.25 1.556 4.213 3.002 5.89 1.765 1.912 3.93 3.6 6.5 4.22.581.105 1.182.17 1.767.063zm4.81-7.262c-.573-.576-.195-1.545-.486-2.273-.614-2.833-2.906-5.21-5.72-5.91-.772-.339-1.767.013-2.43-.51C8.222-.366 9.938.07 10.632.155c2.923.514 5.528 2.577 6.655 5.332a8.568 8.568 0 01.71 3.644c-.034.385-.46.548-.786.414zm-3.74-.378c-.655-.486-.239-1.51-.734-2.153-.615-1.246-1.938-2.116-3.343-2.109-1.088-.256-.112-1.54.69-1.037 2.158.252 3.947 2.16 4.106 4.32.11.49-.1 1.144-.719.979z"}})])
          )
        }
      }
    